<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div ref="output" class="typewriter-output" />
  </div>

</template>

<script>
export default {
  name: 'TypeWriter',
  props: {
    htmlContent: {
      type: String,
      required: true
    },
    typingSpeed: {
      type: Number,
      default: 10 // milliseconds per character
    }
  },
  mounted() {
    this.typeHtml(this.htmlContent);
  },
  methods: {
    typeHtml(fullHtml) {
      const outputEl = this.$refs.output;
      let i = 0;
      let isTag = false;
      let tagBuffer = '';
      let finalBuffer = '';

      const type = () => {
        if (i >= fullHtml.length) {
          this.$emit('doneWriting')
          return;
        }

        const char = fullHtml[i];

        if (char === '<') {
          isTag = true;
          tagBuffer += char;
        } else if (char === '>') {
          tagBuffer += char;
          finalBuffer += tagBuffer;
          tagBuffer = '';
          isTag = false;
          outputEl.innerHTML = finalBuffer;
        } else if (isTag) {
          tagBuffer += char;
        } else {
          finalBuffer += char;
          outputEl.innerHTML = finalBuffer;
        }

        i++;
        setTimeout(type, this.typingSpeed);
      };

      type();
    }
  }
};
</script>

<style scoped>

.typewriter-output {
  font-family: "Courier New", monospace;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.typewriter-output >>> * {
  margin-top: 0;
  margin-bottom: 0;
}
/* Bullet list styling */
.typewriter-output >>> ol {
  padding-left: 1.5em;
}

.typewriter-output >>> ul {
  padding-left: 1.5em;
  list-style-type: disc;
}

.typewriter-output >>> li {
  padding-left: 0.5em;
  text-indent: -0.5em;
}

/* Table styling */
.typewriter-output >>> table {
  width: 100%;
  border-collapse: collapse;
  margin: 1em 0;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.typewriter-output >>> th {
  background-color: #d9d9e3;
  color: #333;
  text-align: left;
  padding: 8px;
  border: 1px solid #ccc;
}

.typewriter-output >>> td {
  padding: 8px;
  border: 1px solid #ccc;
}
</style>



